import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  button: {
    '& *': {
      fontWeight: '500 !important',
    },
  },
}))
